export var ReadWritePermission;
(function (ReadWritePermission) {
    ReadWritePermission[ReadWritePermission["KNOWLEDGE_BASE_R"] = 10] = "KNOWLEDGE_BASE_R";
    ReadWritePermission[ReadWritePermission["KNOWLEDGE_BASE_RW"] = 20] = "KNOWLEDGE_BASE_RW";
    ReadWritePermission[ReadWritePermission["TICKETS_R"] = 30] = "TICKETS_R";
    ReadWritePermission[ReadWritePermission["TICKETS_RW"] = 40] = "TICKETS_RW";
    ReadWritePermission[ReadWritePermission["SAVED_REPLIES_R"] = 50] = "SAVED_REPLIES_R";
    ReadWritePermission[ReadWritePermission["SAVED_REPLIES_RW"] = 60] = "SAVED_REPLIES_RW";
    ReadWritePermission[ReadWritePermission["CALL_CENTER_R"] = 70] = "CALL_CENTER_R";
    ReadWritePermission[ReadWritePermission["CONTACTS_R"] = 80] = "CONTACTS_R";
    ReadWritePermission[ReadWritePermission["CONTACTS_RW"] = 90] = "CONTACTS_RW";
    ReadWritePermission[ReadWritePermission["INSIGHTS_R"] = 100] = "INSIGHTS_R";
    ReadWritePermission[ReadWritePermission["LABELS_R"] = 110] = "LABELS_R";
    ReadWritePermission[ReadWritePermission["LABELS_RW"] = 120] = "LABELS_RW";
    ReadWritePermission[ReadWritePermission["TEAM_MEMBERS_R"] = 130] = "TEAM_MEMBERS_R";
    ReadWritePermission[ReadWritePermission["TEAM_MEMBERS_RW"] = 140] = "TEAM_MEMBERS_RW";
    ReadWritePermission[ReadWritePermission["PERFORM_SSO_LOGIN"] = 160] = "PERFORM_SSO_LOGIN";
})(ReadWritePermission || (ReadWritePermission = {}));
export var FullApiKeysPermissions = Object.keys(ReadWritePermission)
    .filter(function (key) { return typeof ReadWritePermission[key] === 'number'; })
    .map(function (key) { return parseInt(ReadWritePermission[key], 10); });
//# sourceMappingURL=api-key.i.js.map